export default __webpack_public_path__ + "locales/ko-KR/EmptyTrashDialog.json?hash=45cb6a8acb1259c90d79d8092e711952";